<div class="row">
  <div class="col-12">
    @if(message) {
    <ds-empty-state heading="{{message}}" illustration="error" size="lg">
    </ds-empty-state>
    <p style="text-align: center; margin: 0% 5%">
      For roles related issues, please request required roles in
      <span
        style="
          text-decoration: underline;
          color: var(--ds-color-typography-action);
          cursor: pointer;
        "
        (click)="openRightNowPortalInNewTab()"
        >RightNow Portal</span
      >, or contact administrator for help.
    </p>
    }
  </div>
</div>
